import { render, staticRenderFns } from "./SsPagination.vue?vue&type=template&id=5354673c&scoped=true&"
import script from "./SsPagination.vue?vue&type=script&lang=js&"
export * from "./SsPagination.vue?vue&type=script&lang=js&"
import style0 from "./SsPagination.vue?vue&type=style&index=0&id=5354673c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354673c",
  null
  
)

export default component.exports